import React, { useState, useEffect } from "react"

import Alert from 'react-bootstrap/Alert'
import Spinner from 'react-bootstrap/Spinner'
import axios from "axios";
import $ from 'jquery';


function AlertBox(prop) {

    window.alertBox = function(txt, type)
    {
        window.alertOut()
        if( !type ) type = 'ok';
        var aid = '#alert_'+type;
        $(aid).find('.alert-text').html(txt).removeClass('ml-2')
        $(aid).show();
    }
    window.alertOut = function (){ $('.alert-box').hide(); }
    useEffect( function(a){
        window.alertOut();
    })
    return (
        <>
        <Alert id="alert_loading" className="alert-box mt-0" variant="secondary">
        <Spinner animation="border" variant="secondary"  size="sm" role="status">
        <span className="sr-only ">Loading...</span>
        </Spinner>
          <span className="ml-2 alert-text">Loading Dataset. Please wait.</span>
        </Alert>
        <Alert id="alert_err" className="alert-box mt-0" variant="danger">
          <span className="ml-2 alert-text">Loading Dataset. Please wait.</span>
        </Alert>
        <Alert id="alert_ok" className="alert-box mt-0" variant="primary">
          <span className="ml-2 alert-text">Loading Dataset. Please wait.</span>
        </Alert>
        </>
    )
}

export default AlertBox
